export default "__VITE_ASSET__0951e566__"